// smc
export const SHOW_DEFINED_GROUPS = "showDefinedGroups";
export const DUPLICATE_OPTION = "duplicateOption";

// qas
export const MESSAGE_HISTORY = "messageHistory";
export const MODEL_GPT = "modelGpt";
export const PROMPT_IDS = "promptIds";

// ses
export const LIST_OF_SCRIPT_AUTOTEST_PHRASES = "listOfScriptAutotestPhrases";
